import addDays from "../../utils/date-utils/addDays";
import { getTodaysDate, getUrlParams } from './common-utils';

export const parseSeoParamsToConfig = (params) => {
  const { source, destination, tripType, rf, cacheFor = 0, daysOffset = 3 } = params;
  const daysToAdd = (+cacheFor) + (+daysOffset);
  const newDate = addDays(getTodaysDate(), daysToAdd);

  const parseData = {
    startDate: {
      date: newDate,
      time: '10:00 AM' // Fix time to 10:00 AM as per Marketing Team Requirement
    },
    endDate: {
      date: addDays(newDate, 1),
      time: '10:00 AM' // Fix time to 10:00 AM as per Marketing Team Requirement
    },
    source,
    destination,
    tripType: {
      name: tripType,
      rf
    }
  };
  return parseData;
}


export const parseHCBFlag = (url) => {
  const searchParams = getUrlParams(url);
  const { hcb = '' } = searchParams;
  return hcb === '1';
}

export const parseCacheConfig = (url) => {
  const searchParams = getUrlParams(url);
  const { cacheFor = '' } = searchParams;
  if (cacheFor) {
    return parseInt(cacheFor, 10);
  }
  return 0;
}

export const getCacheDate = (days = 0) => {
  if (days > 0) {
    return addDays(getTodaysDate(), days);
  }
  return getTodaysDate();
}

export const parseFlowName = (url) => {
  const searchParams = getUrlParams(url);
  const { flow = '' } = searchParams;
  return flow;
}